import React from "react";

import FrontPageHome from "pages/FrontPage/Home";
import FrontPageSearch from "pages/FrontPage/Search";
import FrontPageLogin from "pages/FrontPage/Auth/login";
import FrontPageBookingsDetails from "pages/FrontPage/Booking/details";
import Pages404 from "pages/Utility/pages-404";
import FrontPageBookingsCreate from "pages/FrontPage/Booking/create";
import Profile from "pages/FrontPage/Profiles/Profile";
import Logout from "pages/FrontPage/Auth/Logout";
import FrontPageRegister from "pages/FrontPage/Auth/registration";

const frontEndRoutes = [
    { path: "/", component: <FrontPageHome /> },
    { path: "/search", component: <FrontPageSearch /> },
    { path: "/booking/:id", component: <FrontPageBookingsDetails /> },
    
    { path: "/logout", component: <Logout /> },
    { path: "/not-found", component: <Pages404 /> },
];

const frontEndRoutesWithAuthDriver = [
    { path: "/create-booking", component: <FrontPageBookingsCreate /> },
];

const frontEndRoutesWithAuthCustomer = [
];

const frontEndRoutesWithAuth = [
    { path: "/profile", component: <Profile /> },
];

const frontEndNotAuthRoutes = [
    { path: "/login", component: <FrontPageLogin /> },
    { path: "/register", component: <FrontPageRegister /> },
];

export { frontEndRoutes, frontEndRoutesWithAuthCustomer, frontEndRoutesWithAuthDriver, frontEndNotAuthRoutes, frontEndRoutesWithAuth }